import { reactMount } from '@/lib/reactMount'
import { useRef } from 'react'
import { Button } from '@/components/Button'
import { getImageByBreakpoint } from '@/lib/media'

export const pageHeaderBlock = ({ dataset, umbraco }) => {
  const umbracoRef = useRef(umbraco || JSON.parse(dataset.umbraco))
  umbraco ||= umbracoRef.current
  const theme = umbraco.Theme || 'dark'
  const backgroundColor = umbraco.BlockBackground ? `#${umbraco.BlockBackground}` : '#f8fafc'
  const imageByBreakpoint = umbraco.Media?.Image ? getImageByBreakpoint(umbraco.Media.Image) : {}

  return (
    <div
      id={umbraco.AnchorTarget || undefined}
      data-theme={theme}
      style={{ backgroundColor }}
      className='_headerBlock-section relative flex isolate min-h-[470] md:min-h-[484] lg:min-h-[496px] text-[--theme-text]'
    >
      <div className='absolute inset-0 -z-10 transform-gpu overflow-hidden _hero-g-l-r'>
        <div className='absolute inset-0 bg-hero-gradient' />
        {
          umbraco.Media && umbraco.Media.Image &&
            <picture>
              {Object.keys(imageByBreakpoint).reverse().map((minWidth) => (
                <source key={minWidth} media={`(min-width: ${minWidth})`} srcSet={imageByBreakpoint[minWidth]} />
              ))}
              <img
                alt={umbraco.Media.Image.AltText}
                src={umbraco.Media.Image.Url}
                className='absolute inset-0 -z-10 size-full object-cover w-full h-full object-center xl:object-right md:object-center'
              />
            </picture>
        }
      </div>

      <div className='grow justify-end mx-auto max-w-7xl flex flex-col lg:gap-x-8 pt-24 pb-20'>
        <div className='max-w-2xl lg:max-w-3xl lg:col-span-7 xl:col-span-6 px-4 py-6 sm:px-6 lg:px-8'>
          {
            umbraco.Label &&
              <span className='uppercase text-[10px] font-extrabold'>{umbraco.Label}</span>
          }
          {
            umbraco.Title &&
              <h1 className='text-balance text-5xl font-extrabold tracking-tight text-[--theme-text] lg:text-6xl mb-4'>
                {umbraco.Title}
              </h1>
          }
          {
            umbraco.Summary &&
              <div
                className='max-w-2xl mb-6 last:mb-0 text-pretty text-base font-semibold text-[--theme-text]'
                dangerouslySetInnerHTML={{ __html: umbraco.Summary }}
              />
          }
          <div className='mt-8 flex items-center justify-start gap-x-6'>
            {
              umbraco.Button &&
                <Button
                  href={umbraco.Button.Url}
                  target={umbraco.Button.Target}
                  variant='primary'
                  size='lg'
                >
                  {umbraco.Button.Name}
                </Button>
            }
            {
              umbraco.ButtonText &&
                <Button
                  href={umbraco.ButtonText.Url}
                  target={umbraco.ButtonText.Target}
                  variant='link'
                  size='lg'
                >
                  {umbraco.ButtonText.Name}
                </Button>
            }
          </div>
        </div>
      </div>
    </div>
  )
}

reactMount('pageHeaderBlock', pageHeaderBlock)
